"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _ProviderOptions = _interopRequireDefault(require("../constants/ProviderOptions"));

var _requestStatus = require("../constants/propTypes/requestStatus");

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _requestStatus2 = require("../utils/requestStatus");

var ProviderDropdown = function ProviderDropdown(_ref) {
  var allProviders = _ref.allProviders,
      disableOptions = _ref.disableOptions,
      fetchProviders = _ref.fetchProviders,
      onGoodFilterChange = _ref.onGoodFilterChange,
      providerFilter = _ref.providerFilter,
      providersRequestStatus = _ref.providersRequestStatus;
  var requestUninitialized = (0, _requestStatus2.isUninitialized)(providersRequestStatus);
  var requestPending = (0, _requestStatus2.isPending)(providersRequestStatus);
  var requestFailed = (0, _requestStatus2.isFailed)(providersRequestStatus);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var renderedErrorMessage = (0, _react.useMemo)(function () {
    return requestFailed && _react.default.createElement(_Small.default, {
      use: "error"
    }, _react.default.createElement(_FormattedJSXMessage.default, {
      message: "sidebar.providerFilter.error_jsx",
      elements: {
        Button: _UIButton.default
      },
      options: {
        onClick: function onClick() {
          return fetchProviders();
        },
        use: 'link'
      }
    }));
  }, [fetchProviders, requestFailed]);
  var options = (0, _react.useMemo)(function () {
    return (0, _utils.getArrOfTextValPairsForSelect)([_ProviderOptions.default.ALL].concat((0, _toConsumableArray2.default)(allProviders)), _langUtils.getProviderOptionText).map(function (option) {
      return (0, _extends2.default)({}, option, {
        disabled: disableOptions
      });
    });
  }, [allProviders, disableOptions]);
  (0, _react.useEffect)(function () {
    if (open && requestUninitialized) {
      fetchProviders();
    }
  }, [fetchProviders, open, requestUninitialized]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIFormControl.default, {
    label: _react.default.createElement(_FormattedMessage.default, {
      message: "sidebar.providerFilter.title"
    }),
    verticalSeparation: "flush"
  }, _react.default.createElement(_UISelect.default, {
    anchorType: "button",
    className: "p-x-0 p-top-0",
    buttonUse: "transparent",
    "data-test-id": "provider-dropdown",
    isLoading: requestPending,
    menuWidth: 250,
    minimumSearchCount: 0,
    onChange: function onChange(evt) {
      return onGoodFilterChange((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PROVIDER, evt.target.value));
    },
    onOpenChange: function onOpenChange(evt) {
      return setOpen(evt.target.value);
    },
    open: open,
    options: options,
    placement: "bottom right",
    searchable: true,
    value: (0, _langUtils.getProviderOptionText)(providerFilter)
  })), renderedErrorMessage);
};

ProviderDropdown.propTypes = {
  allProviders: _propTypes.default.array.isRequired,
  disableOptions: _propTypes.default.bool.isRequired,
  fetchProviders: _propTypes.default.func.isRequired,
  onGoodFilterChange: _propTypes.default.func.isRequired,
  providerFilter: _propTypes.default.string.isRequired,
  providersRequestStatus: _requestStatus.requestStatusPropType.isRequired
};
ProviderDropdown.defaultProps = {
  disableOptions: false
};
var _default = ProviderDropdown;
exports.default = _default;
module.exports = exports.default;